/**
 * マッチング設定一覧ページ（Presentation）
 */

import { Button } from "components/ui/Button";
import { Loading } from "components/ui/Loading/Loading";
import type { MatchingCondition } from "hooks/use-matching-conditions-api";
import type { FC } from "react";
import { Link } from "react-router-dom";
import { MatchingConditionsTable } from "routes/settings/MatchingConditionsPage/MatchingConditionsTable";

type MatchingConditionsPageProps = {
  settings: MatchingCondition[];
  loading: boolean;
  error: { message: string } | null;
  onActivate: (settingId: string) => Promise<void>;
  onDeactivate: (settingId: string) => Promise<void>;
  onDelete: (settingId: string) => Promise<void>;
  isActivating: boolean;
  isDeleting: boolean;
};

export const MatchingConditionsPage: FC<MatchingConditionsPageProps> = ({
  settings,
  loading,
  error,
  onActivate,
  onDeactivate,
  onDelete,
  isActivating,
  isDeleting,
}) => {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold">マッチング条件設定</h1>
          <p className="text-base-content/60 mt-1">
            マッチングの条件やモードを管理できます
          </p>
        </div>
        <Button asChild size="sm">
          <Link to="/settings/matching/conditions/new">+ 新規作成</Link>
        </Button>
      </div>

      {loading ? (
        <div className="flex justify-center py-8">
          <Loading size="lg" />
        </div>
      ) : error ? (
        <div className="alert alert-error">
          <span>{error.message}</span>
        </div>
      ) : (
        <MatchingConditionsTable
          settings={settings}
          onActivate={onActivate}
          onDeactivate={onDeactivate}
          onDelete={onDelete}
          isActivating={isActivating}
          isDeleting={isDeleting}
        />
      )}
    </div>
  );
};
